// "An evening by the Ganges": a wedding night at the ghat felt only as light and sound → everyone leaves → hold back the dawn → the agnikund's fire goes out in a last curl of smoke → the painting.
export const ganges = {
  slug: "an-evening-by-the-ganges",
  duration: 30,
  // the wedding: a bright santoor-and-sitar tune over light tabla/dholak with laughter (no shehnai, no dhaak); it crossfades into the river-and-bells dawn as the party leaves
  music: "ganges-wedding",
  calmMusic: "ganges-dawn",
  music2: [8, "ganges-dawn"],
  captionTail: "We rush to the next step. But wait a little; not just yet.",
  stages: [
    { id: "night", at: 0, hint: "the wedding night at the ghat" },
    { id: "leave", at: 7, hint: "everyone leaves" },
    { id: "dawn", at: 12, hint: "hold to stay a moment more" },
    { id: "out", at: 23.5, hint: "" },
  ],
  slowHold: [12, 23.5],
  // painted panoramas (night celebration → the quiet after → dawn), cross-faded like one long shot, with a living agnikund flame and diyas drifting downstream
  layers: [
    // the wedding at the ghat: guests in silks under the flower archway, the agnikund blazing; then the party leaves up the steps and the fire keeps burning
    { src: "/arcs/ganges/wedding.webp", wrap: 3.48, th: 0, h: 8.4, y: 1.8, r: 4.9, water: 0.3, mist: 0.06, mistCol: "#4b4f7a", show: [-1, 0, 6, 9.5] },
    { src: "/arcs/ganges/leaving.webp", wrap: 3.48, th: 0, h: 8.4, y: 1.8, r: 4.9, water: 0.34, mist: 0.08, mistCol: "#5a5b86", show: [6, 9.5, 12.5, 16.5] },
    { src: "/arcs/ganges/dawn.webp", wrap: 3.48, th: 0, h: 8.4, y: 1.8, r: 4.9, water: 0.33, mist: [[12, 0.6], [18, 0.38], [24, 0.12]], mistCol: "#f3dcd6", show: [12.5, 16.5, 99, 99] },
    { src: "/arcs/ganges/flame.webp", add: true, flicker: 1, glow: 0.5, th: -0.14, y: 1.45, w: 0.95, h: 0.95, r: 4.6, show: [12.5, 16.5, 23.5, 26] },
    { src: "/arcs/ganges/diyas.webp", add: true, flicker: 0.35, th: 0.45, y: 0.15, w: 3.4, h: 2.3, r: 4.4, drift: [7, 25, -0.1, 0.55], show: [7.5, 10.5, 22, 25.5] },
  ],
  touch: { kind: "press", from: 12, until: 23.5 },
  line: { text: "There is such beauty in arriving.", from: 17, to: 29.5, pos: "low" },
  cues: [[1.6, "laugh"], [2.6, "laugh"], [4.4, "laugh"], [5.4, "laugh"], [6.6, "laugh"], [19, "bellSoft"], [22, "bellSoft"]],
  ambient: { scene: "ghat", until: 99, then: [] },
  look: { start: 0.06, lift: [0, 1], end: 0.06, yaw: [[0, 0.5], [6, -0.3], [9.5, 0], [30, 0]] },
  calm: { duration: 12, fade: [4, 8.5], line: [5.5, 11.5], backdrop: "ganges", pos: "low" },
  speed: [[0, 1], [30, 1]],
  frag: `
uniform sampler2D uMap;
uniform vec4 uCrop;
uniform float uT, uAspect, uTileH, uRadius, uCy, uSurface, uWarm;
varying vec3 vPos;
${"__NOISE__"}
float hash1(float n){ return fract(sin(n * 91.7) * 43758.5453); }
float hash2(vec2 p){ return fract(sin(dot(p, vec2(41.3, 289.1))) * 43758.5453); }
vec3 tap(vec2 uv){
  vec2 m = 1.0 - abs(1.0 - mod(uv, 2.0));
  return texture2D(uMap, mix(uCrop.xy, uCrop.zw, m)).rgb;
}
// a diya's flame: a small flickering teardrop
float flame(vec2 p, float h, float t){
  p.x += 0.1 * h * sin(t * 9.0 + p.y * 40.0) * smoothstep(0.0, h, p.y);
  float s = clamp((p.y + 0.2 * h) / (1.2 * h), 0.0, 1.0);
  float w = 0.55 * h * sqrt(s) * (1.0 - s);
  return (1.0 - smoothstep(w * 0.6, w, abs(p.x))) * step(-0.2 * h, p.y) * step(p.y, h);
}
void main(){
  float n = snoise(vPos * 0.6) * 0.5 + 0.5;
  float n2 = snoise(vPos * 3.0 + 4.0) * 0.5 + 0.5;
  float th = atan(vPos.x, -vPos.z);
  float dawn = smoothstep(12.0, 23.0, uT);
  float party = 1.0 - smoothstep(7.0, 11.0, uT);
  float fire = 1.0 - smoothstep(23.5, 26.0, uT);
  float settle = smoothstep(25.5, 29.5, uT);
  vec3 col;
  vec2 local;
  if (uSurface < 0.5) {
    float X = th * uRadius;
    float y = vPos.y;
    // the sky: deep night blue, then the first light of dawn over the river
    vec3 night = mix(vec3(0.07, 0.09, 0.26), vec3(0.02, 0.03, 0.11), smoothstep(1.5, 6.0, y));
    vec3 morn = mix(mix(vec3(0.98, 0.66, 0.46), vec3(0.62, 0.5, 0.72), smoothstep(1.5, 3.2, y)), vec3(0.28, 0.36, 0.68), smoothstep(3.0, 7.0, y));
    col = mix(night, morn, dawn) * (0.92 + 0.12 * n);
    // red and white streaks of morning sky
    float sk = snoise(vec3(X * 0.18, y * 4.0, 2.0));
    col = mix(col, vec3(0.86, 0.26, 0.24), smoothstep(0.45, 0.75, sk) * dawn * 0.75 * step(1.6, y));
    col = mix(col, vec3(0.98, 0.95, 0.9), smoothstep(0.55, 0.8, -sk) * smoothstep(0.3, 1.0, dawn) * 0.6 * step(1.6, y));
    // the sun's first sliver rising over the far bank
    float sun = 1.0 - smoothstep(0.32, 0.36, length(vec2(X - 2.6, y - 1.45 - 0.35 * smoothstep(19.0, 26.0, uT))));
    col = mix(col, vec3(1.0, 0.86, 0.55), sun * smoothstep(17.0, 21.0, uT) * step(1.45, y));
    // the far bank of temples and ghats
    float bank = 1.45 + 0.08 * snoise(vec3(X * 1.3, 0.0, 1.0)) + 0.22 * step(0.6, fract(X * 0.35)) * step(fract(X * 0.35), 0.75);
    if (y < bank && y > 1.3) col = mix(vec3(0.05, 0.05, 0.1), vec3(0.42, 0.3, 0.36), dawn) * (0.9 + 0.2 * n2);
    // the Ganga: horizontal blue strokes, the fire's gold mirrored in them
    if (y <= 1.3 && y > 0.45) {
      float strokes = snoise(vec3(X * 0.5, y * 18.0, uT * 0.08)) * 0.5 + 0.5;
      col = mix(mix(vec3(0.03, 0.06, 0.2), vec3(0.18, 0.34, 0.66), strokes), mix(vec3(0.3, 0.45, 0.8), vec3(0.75, 0.62, 0.7), strokes), dawn);
      float gl = exp(-X * X * 5.0) * smoothstep(0.55, 0.9, snoise(vec3(X * 2.0, y * 30.0, uT * 0.6)) * 0.5 + 0.5);
      col += vec3(1.0, 0.6, 0.2) * gl * fire * 0.8;
      col += vec3(1.0, 0.85, 0.6) * exp(-pow(X - 2.6, 2.0) * 2.0) * strokes * smoothstep(17.0, 22.0, uT) * 0.5;
    }
    // the ghat steps, the river lapping at the last one
    float lapY = 0.45 + 0.03 * sin(X * 2.7 + uT * 1.4) + 0.02 * sin(X * 5.3 - uT * 1.9);
    if (y <= lapY) {
      float stp = fract(y * 6.0);
      col = mix(vec3(0.16, 0.13, 0.14), vec3(0.62, 0.5, 0.42), dawn) * (0.85 + 0.15 * smoothstep(0.0, 0.1, stp)) * (0.9 + 0.2 * n2);
      col += vec3(0.8, 0.85, 1.0) * (1.0 - smoothstep(0.0, 0.025, lapY - y)) * 0.35;
    }
    // the celebration felt only as light: coloured beams sweeping the walls
    for (int i = 0; i < 3; i++){
      float fi = float(i);
      float bm = exp(-pow(sin(X * 0.35 - uT * (0.5 + fi * 0.2) + fi * 2.1), 2.0) * 40.0);
      vec3 bc = fi < 0.5 ? vec3(1.0, 0.4, 0.6) : fi < 1.5 ? vec3(1.0, 0.75, 0.3) : vec3(0.5, 0.7, 1.0);
      col += bc * bm * party * 0.16 * smoothstep(0.5, 3.0, y);
    }
    // strings of festival lamps above, going dark one by one as everyone leaves
    float sg = floor(X / 1.6);
    float fx = fract(X / 1.6) * 2.0 - 1.0;
    float sy = 4.1 - 0.35 * (1.0 - fx * fx) + 0.03 * sin(uT * 0.8 + sg);
    float off = 1.0 - smoothstep(0.0, 0.6, uT - (7.2 + hash1(sg) * 3.6));
    col = mix(col, vec3(0.1, 0.08, 0.08), (1.0 - smoothstep(0.004, 0.01, abs(y - sy))) * 0.7);
    float li = floor(X / 0.27);
    float lx = (fract(X / 0.27) - 0.5) * 0.27;
    float ly = y - sy + 0.07;
    float lamp = (1.0 - smoothstep(0.03, 0.04, abs(lx))) * (1.0 - smoothstep(0.03, 0.045, abs(ly)));
    vec3 lc = mix(mix(vec3(1.0, 0.75, 0.25), vec3(1.0, 0.35, 0.45), step(0.5, hash1(li))), vec3(0.45, 0.85, 1.0), step(0.8, hash1(li + 7.0)));
    float tw = 0.7 + 0.3 * sin(uT * 3.0 + li * 1.7);
    col = mix(col, lc * 1.2, lamp * off * tw);
    col += lc * exp(-(lx * lx + ly * ly) * 300.0) * off * tw * 0.4;
    // the flower-and-diya archway
    float ad = y < 2.0 ? abs(abs(X) - 1.15) : abs(length(vec2(X / 1.15, (y - 2.0) / 1.3)) - 1.0) * 1.15;
    float band = (1.0 - smoothstep(0.13, 0.15, ad)) * step(0.15, y) * step(abs(X), 1.4);
    vec2 fc = vec2(X, y) / 0.075;
    vec2 cell = floor(fc);
    vec2 fp = fract(fc) - 0.5;
    float h = hash2(cell);
    float ang = atan(fp.y, fp.x) + h * 6.28;
    float floret = 1.0 - smoothstep(0.32, 0.4, length(fp) / (0.75 + 0.25 * cos(5.0 * ang)));
    vec3 fl = h < 0.35 ? vec3(0.98, 0.55, 0.08) : h < 0.6 ? vec3(1.0, 0.82, 0.15) : h < 0.78 ? vec3(0.85, 0.12, 0.18) : h < 0.9 ? vec3(0.98, 0.95, 0.9) : vec3(0.95, 0.45, 0.65);
    float lit = mix(0.35, 1.0, max(party, max(fire * 0.6, dawn)));
    col = mix(col, mix(vec3(0.15, 0.25, 0.08), fl, floret) * lit, band);
    // a row of diyas along the top step, still burning after everyone has gone
    float dx = mod(X + 0.175, 0.35) - 0.175;
    float row = step(0.6, abs(X)) * step(abs(X), 3.6);
    float diyaOn = 1.0 - 0.8 * smoothstep(20.0, 25.0, uT);
    vec2 dp = vec2(dx, y - 0.27);
    float bowl = (1.0 - smoothstep(0.04, 0.05, length(dp * vec2(1.0, 2.2)))) * step(dp.y, 0.0) * row;
    col = mix(col, vec3(0.55, 0.25, 0.12), bowl);
    col = mix(col, vec3(1.0, 0.85, 0.4), flame(vec2(dx, y - 0.28), 0.09, uT + X * 3.0) * row * diyaOn);
    col += vec3(1.0, 0.6, 0.2) * exp(-(dx * dx + pow(y - 0.32, 2.0)) * 300.0) * row * diyaOn * 0.35;
    // the agnikund: a copper vessel, its fire yellow and black at the heart of the arch
    vec2 kp = vec2(X, y - 0.3);
    float kund = step(abs(kp.x), 0.3 - kp.y * 0.25) * step(-0.18, kp.y) * step(kp.y, 0.12);
    col = mix(col, mix(vec3(0.35, 0.14, 0.08), vec3(0.75, 0.38, 0.18), smoothstep(-0.18, 0.12, kp.y)) * (0.8 + 0.4 * fire), kund);
    float fh = (0.95 + 0.1 * sin(uT * 2.3)) * (0.25 + 0.75 * fire) * (1.0 + 0.15 * uWarm);
    vec2 q = vec2(X, y - 0.42);
    float yy = clamp(q.y / fh, 0.0, 1.0);
    float qx = q.x + 0.16 * yy * snoise(vec3(q.x * 2.5, q.y * 3.0 - uT * 2.2, uT * 0.4));
    float fw = 0.3 * pow(1.0 - yy, 0.8) * smoothstep(-0.02, 0.06, q.y);
    float fin = (1.0 - smoothstep(fw * 0.75, fw, abs(qx))) * step(q.y, fh) * step(-0.02, q.y) * step(0.01, fire);
    float tongues = snoise(vec3(qx * 6.0, q.y * 4.0 - uT * 3.0, 3.0));
    vec3 fcol = mix(vec3(1.0, 0.92, 0.35), vec3(1.0, 0.55, 0.1), smoothstep(0.2, 0.75, abs(qx) / max(fw, 0.001) + yy * 0.4));
    fcol = mix(fcol, vec3(0.04, 0.03, 0.03), smoothstep(0.35, 0.6, tongues) * smoothstep(0.25, 0.7, yy));
    col = mix(col, fcol, fin);
    col += vec3(1.0, 0.55, 0.18) * exp(-length(vec2(X, (y - 0.7) * 0.8)) * 1.6) * (0.45 + 0.25 * uWarm) * fire;
    // the last curl of smoke as the fire goes out
    float sm = smoothstep(23.8, 25.0, uT) * (1.0 - smoothstep(27.5, 29.0, uT));
    float sy2 = y - 0.45;
    float sx = 0.18 * sy2 * sin(sy2 * 3.2 - uT * 0.9) + 0.05 * sin(sy2 * 7.0 + uT);
    float wisp = (1.0 - smoothstep(0.008 + 0.03 * sy2, 0.02 + 0.06 * sy2, abs(X - sx))) * step(0.0, sy2) * (1.0 - smoothstep((uT - 23.8) * 0.7 - 0.5, (uT - 23.8) * 0.7, sy2));
    col = mix(col, vec3(0.78, 0.76, 0.8), wisp * sm * 0.6 * (1.0 - smoothstep(1.0, 2.6, sy2)));
    local = vec2(X, y - uCy);
  } else if (uSurface < 1.5) {
    vec2 p = vPos.xz;
    col = mix(vec3(0.13, 0.11, 0.12), vec3(0.6, 0.5, 0.42), dawn) * (0.85 + 0.2 * n);
    // marigold petals strewn on the steps after the ceremony
    vec2 pc = p / 0.22;
    vec2 ci = floor(pc);
    float h = hash2(ci);
    float a = h * 6.28;
    vec2 r = mat2(cos(a), -sin(a), sin(a), cos(a)) * (fract(pc) - 0.5 - (vec2(hash2(ci + 3.0), hash2(ci + 7.0)) - 0.5) * 0.5);
    float petal = (1.0 - smoothstep(0.8, 1.0, length(r / vec2(0.16, 0.07)))) * step(0.55, h);
    col = mix(col, (h < 0.8 ? vec3(0.95, 0.5, 0.08) : vec3(0.9, 0.15, 0.2)) * mix(0.55, 1.0, max(dawn, fire * 0.7)), petal);
    col += vec3(1.0, 0.55, 0.18) * exp(-length(p - vec2(0.0, -uRadius + 0.4)) * 0.7) * 0.4 * fire;
    local = vPos.xz;
  } else {
    col = mix(vec3(0.02, 0.03, 0.11), vec3(0.3, 0.38, 0.7), dawn);
    local = vPos.xz;
  }
  vec2 tile = vec2(uTileH * uAspect, uTileH);
  vec3 paint = tap(local / tile + 0.5);
  float drip = uSurface < 0.5 ? (10.0 - vPos.y) / 10.0 : 0.5 + length(vPos.xz) / (uRadius * 3.0);
  col = mix(col, paint, smoothstep(0.0, 0.25, settle * 1.3 - drip * 0.6 - n * 0.25));
  gl_FragColor = vec4(clamp(col, 0.0, 1.0), 1.0);
  #include <colorspace_fragment>
}`,
};
